import styled from 'styled-components';

export const DestinationContainer = styled.div`
  max-height: 150px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.light_gray || '#f1f1f1'};
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.primary || '#888'};
    border-radius: 10px;
    border: 2px solid ${({ theme }) => theme.colors.light_gray || '#f1f1f1'};
    transition: background-color 0.3s ease, border 0.3s ease;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${({ theme }) => theme.colors.secondary || '#555'};
    border-color: ${({ theme }) => theme.colors.primary || '#888'};
  }

  scroll-behavior: smooth;
`;

export const DestinationItem = styled.div`
  padding: 4px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.light_gray || '#e6e6e6'};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:last-child {
    border-bottom: none;
  }
`;
